import { Component } from '@angular/core';
import { GlobalStateService } from '../../services/global-state.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  isShowFooter: any;
  currentYear = new Date().getFullYear()

  constructor(private readonly globalStateService: GlobalStateService) { }

  ngOnInit(): void {
    this.globalStateService.footerVisibleSubject.subscribe({
      next: (data: any) => {
        console.log(data)
        this.isShowFooter = data;
      },
    });
  }

}
